import { serverAjaxPromise } from './request_helpers';

const requestElevations = encodedPolylines => {
  if (encodedPolylines.length < 1) {
    return Promise.resolve([]);
  }
  return serverAjaxPromise({
    type: 'POST',
    url: `/api/alltrails/elevator`,
    data: {
      paths: encodedPolylines
    }
  });
};

export { requestElevations };
